module.exports = __webpack_public_path__ + "static/media/slack-hero.b89fd988.png";